import React, { ReactNode } from 'react';
import { AvTooltip } from '@fabric-ui/components';
import { WarningFullOrange } from '@fabric-ui/icons/colorful';
import { iconSize } from '@fabric-ui/utils';

export const EXCLUDED_VALUE_TOOLTIP = 'No values are available based on the current filter selections';

const warningIcon = <WarningFullOrange style={iconSize(16)} />;

/** A selected value the cascaded options query no longer returns - dimmed, with a warning icon explaining why. */
export const ExcludedOptionLabel: React.FC<{ children: ReactNode }> = ({ children }) => (
  <div className="flex w-full items-center justify-between gap-1">
    <div className="min-w-0 truncate">{children}</div>
    {/* hasWidthLimit drops MUI's 300px tooltip maxWidth, so the message stays on a single line. */}
    <AvTooltip title={EXCLUDED_VALUE_TOOLTIP} hasWidthLimit={false}>
      <span className="flex shrink-0 items-center justify-center">{warningIcon}</span>
    </AvTooltip>
  </div>
);
